import { render } from "./PortfolioAnimals.vue?vue&type=template&id=06210644&scoped=true"
import script from "./PortfolioAnimals.vue?vue&type=script&lang=js"
export * from "./PortfolioAnimals.vue?vue&type=script&lang=js"

import "./PortfolioAnimals.vue?vue&type=style&index=0&id=06210644&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06210644"]])

export default __exports__